import React from 'react';
import { Form } from 'react-bootstrap';
import TextInput from '../TextInput';

function InputWithSuggest({
    label,
    name,
    value,
    type,
    onChange,
    onFocus,
    placeholder,
    loading,
    suggestions,
    map
}) {
    
    return (
        <Form.Group className='mb-10 fv-row fv-plugins-icon-container'>
        <Form.Label className='form-label'>{label}</Form.Label>
        <TextInput
            type={type}
            name={name}
            value={value}
            placeholder={placeholder}
            onChange={onChange}
            onFocus={onFocus}
        />
        {loading && (
            <div className="d-flex align-items-center gap-2 my-2">
                <div className="spinner-border text-primary" role="status" style={{width: '1.5rem', height: '1.5rem'}}>
                    <span className="visually-hidden">Loading...</span>
                </div>
                <span>Loading suggestions...</span>
            </div>
        )}
        {
            suggestions.length > 0 ? (
                <ul
                    style={{
                        listStyleType: "none",
                        padding: 0,
                        margin: "10px 0",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        maxHeight: "150px",
                        overflowY: "auto",
                        backgroundColor: "#fff",
                    }}
                >
                    {map}
                </ul>
            ) : (
                <ul
                    style={{
                        listStyleType: "none",
                        padding: 0,
                        margin: "10px 0",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        maxHeight: "150px",
                        overflowY: "auto",
                        backgroundColor: "#fff",
                    }}
                >
                    {map}
                </ul>
            )
        }
        </Form.Group>
    );
}

export default InputWithSuggest;
